<template>
  <form>
    <p class="text-muted">
      Les combinaisons permettent de regrouper des produits complémentaires, par exemple dans une partie &laquo;&nbsp;Haut&nbsp;&raquo; et une partie &laquo;&nbsp;Bas&nbsp;&raquo;.<br />
      Elles peuvent également être utilisées pour regrouper au sein d'une dénomination des produits&nbsp;: il est possible de créer une combinaison &laquo;&nbsp;Gilet&nbsp;&raquo;,
      avec une seule partie &laquo;&nbsp;Tous&nbsp;&raquo;, puis d'y associer tous les gilets avec des options (ex : &laquo;&nbsp;Gilet avec poches&nbsp;&raquo;, &laquo;&nbsp;Gilet sans poche&nbsp;&raquo;).
    </p>
    <p class="text-danger"><i class="icon-warning position-left" />Les modifications sur cette liste sont automatiquement et directement enregistrées.</p>
    <hr />
    <div class="table-responsive">
      <table class="table table-striped table-lg">
        <thead>
        <tr>
          <th width="200">Nom</th>
          <th>Parties</th>
          <th width="80" class="text-center">Actions</th>
        </tr>
        </thead>
        <tbody v-if="combinations.length">
        <tr v-for="combination in combinations" :key="combination.id">
          <td>
            <form-input type="text" :value="combination.name" required @change="updateCombinationName(combination, $event)" />
          </td>
          <td>
            <row>
              <column md="4" v-for="part in combination.parts" :key="part.id">
                <div class="input-group">
                  <form-input type="text" :value="part.name" @change="updateCombinationPartName(combination, part, $event)" />
                  <span class="input-group-btn"><button class="btn btn-default" type="button" @click.prevent="updateCombinationPartName(combination, part, '')"><i class="icon-cross" /></button></span>
                </div>
              </column>
              <column md="4">
                <div class="input-group">
                  <form-input type="text" placeholder="Nouvelle partie" @change="updateCombinationPartName(combination, null, $event)" />
                  <span class="input-group-btn"><button class="btn btn-default" type="button"><i class="icon-check" /></button></span>
                </div>
              </column>
            </row>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-warning" @click="deleteCombination(combination)"><i class="icon-bin" /></button>
          </td>
        </tr>
        </tbody>
        <tbody v-else-if="$apollo.loading">
        <tr>
          <td colspan="3" class="text-center">
            <h4>Chargement&hellip;</h4>
          </td>
        </tr>
        </tbody>
        <tbody>
        <tr>
          <td colspan="3" class="text-center">
            <button class="btn btn-success" type="button" @click="addCombination">Ajouter une combinaison</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </form>
</template>

<script>
import _map from "lodash/map";
import _omit from "lodash/omit";

import CombinationListQuery from "./graphql/CombinationListQuery.gql";
import CombinationCreateMutation from "./graphql/CombinationCreateMutation.gql";
import CombinationUpdateMutation from "./graphql/CombinationUpdateMutation.gql";
import CombinationRemoveMutation from "./graphql/CombinationRemoveMutation.gql";

export default {
  components: {},
  data() {
    return {
      results: {
        totalCount: 0,
        edges: []
      },
      colorGroups: [],
      colorEdited: null,
      addColorFormVisible: false
    };
  },
  apollo: {
    results: {
      query: CombinationListQuery,
      fetchPolicy: "network-only",
      variables() {
        return {
          pagination: {
            after: 0,
            limit: 999
          }
        };
      }
    }
  },
  computed: {
    combinations() {
      return _map(this.results.edges, "node");
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.refresh();
    });
  },
  methods: {
    refresh() {
      this.$apollo.queries.results.refetch();
    },
    async deleteCombination(combination) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CombinationRemoveMutation,
          variables: {
            id: combination.id
          }
        });
        this.refresh();
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    },
    async addCombination() {
      try {
        await this.$apollo.mutate({
          mutation: CombinationCreateMutation,
          variables: {
            data: { name: "Nouvelle combinaison" }
          }
        });
        this.refresh();
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    },
    updateCombinationName(combination, name) {
      return this.updateCombination({ ...combination, name });
    },
    updateCombinationPartName(combination, part, name) {
      if (!part && name) {
        return this.updateCombination({
          ...combination,
          parts: [...combination.parts, { name }]
        });
      }
      return this.updateCombination({
        ...combination,
        parts: combination.parts
          .map(myPart => (myPart.id === part.id ? { ...myPart, name } : myPart))
          .filter(({ name }) => !!name)
      });
    },
    async updateCombination(combination) {
      const { id, ...data } = combination;
      try {
        await this.$apollo.mutate({
          mutation: CombinationUpdateMutation,
          variables: {
            id,
            data: _omit(
              {
                ...data,
                parts: _map(data.parts, part => _omit(part, ["__typename"]))
              },
              ["__typename"]
            )
          }
        });
        this.refresh();
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/combinations/Combinations.vue